import { render, staticRenderFns } from "./dispatch-outsourcing.vue?vue&type=template&id=d06c5688&scoped=true"
var script = {}
import style0 from "./dispatch-outsourcing.vue?vue&type=style&index=0&id=d06c5688&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06c5688",
  null
  
)

export default component.exports